import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer h-4 w-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focusRing focus-visible:ring-offset-2 focus-visible:ring-offset-background data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
      className
    )}
    {...props}
    ref={ref}
  >
    {/* Disabled state lives on SwitchPrimitives.Root via Radix's
        `data-disabled` attribute. `:disabled` pseudo-class does not apply to
        a <div>, so `disabled:cursor-not-allowed disabled:opacity-50` here was
        dead CSS — removed in favor of the Root-level data-[disabled]:*. */}
    <div className="peer inline-flex h-[4px] w-10 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors bg-input">
      <SwitchPrimitives.Thumb
        className={cn(
          // Unchecked thumb uses `bg-btn-secondary` (slate-200) — a light neutral
          // grey appropriate for an "off" visual state. Previously used
          // `bg-secondary` (slate-400), but the 2026-04-20 WCAG AA bugbash raised
          // `--secondary` to slate-600, which would have rendered the off-thumb
          // as a dark chip on a light track. Not a contrast failure, but a
          // visual regression. `--btn-secondary` is the semantic match for
          // "neutral light surface."
          "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 data-[state=unchecked]:bg-btn-secondary data-[state=checked]:bg-success"
        )}
      />
    </div>

  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
